import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelRadio as _vModelRadio, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal-backdrop",
  tabindex: "-1"
}
const _hoisted_2 = {
  class: "modal-dialog modal-fullscreen",
  style: {"z-index":"999999 !important"}
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "modal-body-left" }
const _hoisted_7 = { class: "form-row" }
const _hoisted_8 = { class: "input-group" }
const _hoisted_9 = {
  for: "basic-url",
  style: {"font-size":"16px"}
}
const _hoisted_10 = { class: "custom-file" }
const _hoisted_11 = { class: "form-row" }
const _hoisted_12 = {
  for: "settingName",
  style: {"font-size":"16px"}
}
const _hoisted_13 = { style: {"position":"relative","flex":"1","min-width":"0"} }
const _hoisted_14 = ["placeholder"]
const _hoisted_15 = { class: "tktTex form-row" }
const _hoisted_16 = {
  for: "basic-url",
  style: {"font-size":"16px"}
}
const _hoisted_17 = { class: "input-group mb-3" }
const _hoisted_18 = { class: "form-check form-check-inline" }
const _hoisted_19 = {
  class: "form-check-label",
  for: "inlineRadio1"
}
const _hoisted_20 = { class: "form-check form-check-inline" }
const _hoisted_21 = {
  class: "form-check-label",
  for: "inlineRadio2"
}
const _hoisted_22 = { class: "form-row" }
const _hoisted_23 = {
  for: "basic-url",
  style: {"font-size":"16px"}
}
const _hoisted_24 = { class: "search row height d-flex align-items-center" }
const _hoisted_25 = {
  class: "stitchType",
  style: {"padding":"13px"}
}
const _hoisted_26 = { class: "form-row" }
const _hoisted_27 = {
  for: "basic-url",
  style: {"font-size":"16px"}
}
const _hoisted_28 = { class: "search row height d-flex align-items-center" }
const _hoisted_29 = {
  class: "stitchType",
  style: {"padding":"13px"}
}
const _hoisted_30 = { class: "form-row" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "modal-body-right" }
const _hoisted_35 = { style: {"margin-top":"10px","font-weight":"bold","color":"#0054a6"} }
const _hoisted_36 = {
  key: 0,
  style: {"margin-top":"15px"}
}
const _hoisted_37 = ["disabled"]
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = {
  key: 1,
  style: {"margin-top":"15px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertComponent = _resolveComponent("AlertComponent")!
  const _component_ComboBox = _resolveComponent("ComboBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "modal-close",
          "aria-label": "Close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isCancelButtonClicked = true))
        }, [...(_cache[13] || (_cache[13] = [
          _createElementVNode("span", { "aria-hidden": "true" }, [
            _createElementVNode("i", {
              class: "fa fa-times",
              "aria-hidden": "true"
            })
          ], -1)
        ]))]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("headerSideMenuV1.uploadSeamworksDatabase")), 1)
        ]),
        (_ctx.isCancelButtonClicked)
          ? (_openBlock(), _createBlock(_component_AlertComponent, {
              key: 0,
              onSetWindow: _ctx.handleSetWindow,
              isCancelButtonClicked: _ctx.isCancelButtonClicked,
              onHidePopup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isCancelButtonClicked = false))
            }, null, 8, ["onSetWindow", "isCancelButtonClicked"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("uploadDatabase.chooseFile")), 1),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("label", {
                    class: "custom-file-label",
                    for: "inputGroupFile04",
                    ref: "fileLabel"
                  }, _toDisplayString(_ctx.$t("uploadDatabase.chooseFile")), 513),
                  _createElementVNode("input", {
                    type: "file",
                    class: "custom-file-input",
                    id: "inputGroupFile04",
                    "aria-describedby": "inputGroupFileAddon04",
                    onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.updateFileName && _ctx.updateFileName(...args))),
                    accept: ".xlsx"
                  }, null, 32)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("uploadDatabase.saveSettingsAs")), 1),
              _createElementVNode("div", _hoisted_13, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.checkCustomSettingName && _ctx.checkCustomSettingName(...args))),
                  class: _normalizeClass(["form-control", { errorStyle: _ctx.customSettingNameError }]),
                  id: "basic-url",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newCustomSetting.name) = $event)),
                  maxlength: 20,
                  placeholder: _ctx.placeholder,
                  style: {"border-radius":"10px"},
                  "aria-describedby": "basic-addon3"
                }, null, 42, _hoisted_14), [
                  [_vModelText, _ctx.newCustomSetting.name]
                ]),
                _createElementVNode("span", {
                  class: _normalizeClass(["counter", { errorCounter: _ctx.customSettingNameCountError }])
                }, _toDisplayString(_ctx.newCustomSetting?.name?.length) + "/20", 3)
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("uploadDatabase.threadSize")), 1),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    name: "inlineRadioOptions",
                    id: "inlineRadio1",
                    value: "Tkt",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedTktTex) = $event))
                  }, null, 512), [
                    [_vModelRadio, _ctx.selectedTktTex]
                  ]),
                  _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("addCustomSetting.tkt")), 1)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    name: "inlineRadioOptions",
                    id: "inlineRadio2",
                    value: "Tex",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedTktTex) = $event))
                  }, null, 512), [
                    [_vModelRadio, _ctx.selectedTktTex]
                  ]),
                  _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t("addCustomSetting.tex")), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t("uploadDatabase.language")), 1),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_ComboBox, {
                    ref: "LanguageData",
                    "data-source": _ctx.LanguageData,
                    height: 265,
                    maxlength: 30,
                    filter: 'contains',
                    placeholder: 'Select Language',
                    style: { width: '20em !important' },
                    "data-text-field": 'text',
                    "data-value-field": 'value',
                    value: _ctx.selectedLanguage,
                    onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.validateLanguage($event.sender.value())))
                  }, null, 8, ["data-source", "value"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t("styleGrid.customer")), 1),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_ComboBox, {
                    "data-source": _ctx.customers.length ? _ctx.customers : [],
                    "data-text-field": 'text',
                    "data-value-field": 'value',
                    height: 275,
                    maxlength: 30,
                    filter: 'contains',
                    placeholder: 'Select Customer',
                    value: _ctx.customerVal,
                    "min-filter-length": 0,
                    onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.validateCustomer($event.sender.text(), $event.sender.value()))),
                    style: { width: '20em !important' },
                    required: true
                  }, null, 8, ["data-source", "value"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("button", {
                type: "submit",
                class: _normalizeClass(["btn btn-sm btn-primary submitButton", { 'btn-secondary': !_ctx.canStartNewUpload }]),
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args))),
                disabled: !_ctx.canStartNewUpload
              }, [
                (_ctx.pollingInterval || _ctx.isSubmitting)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                      _cache[14] || (_cache[14] = _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.uploadButtonText), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.uploadButtonText), 1))
              ], 10, _hoisted_31)
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _cache[16] || (_cache[16] = _createElementVNode("span", null, "Status", -1)),
            _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.statusMessage), 1),
            (_ctx.showDownloadFailedButton)
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-sm btn-warning",
                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.downloadFailedRecords && _ctx.downloadFailedRecords(...args))),
                    disabled: _ctx.downloadingReport,
                    style: {"border-radius":"5px"}
                  }, [
                    (_ctx.downloadingReport)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_38, [...(_cache[15] || (_cache[15] = [
                          _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1),
                          _createTextVNode(" Downloading... ", -1)
                        ]))]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_39, " Download Failed Records "))
                  ], 8, _hoisted_37)
                ]))
              : _createCommentVNode("", true),
            (_ctx.currentImportId && !_ctx.pollingInterval)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  (!_ctx.uploadCompleted && !_ctx.uploadFailed)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-sm btn-info",
                        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.manualStatusCheck && _ctx.manualStatusCheck(...args))),
                        style: {"border-radius":"5px","margin-right":"10px"}
                      }, " Check Status "))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-sm btn-secondary",
                    onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.clearCurrentUpload && _ctx.clearCurrentUpload(...args))),
                    style: {"border-radius":"5px","margin-right":"10px"}
                  }, " Clear ")
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}